export enum Routes {
  index = '/',
  fence = '/1',
  roof = '/2',
}
